import styled, { css } from 'styled-components';

import { theme } from 'theme';
import { Button } from '@components/atoms';
import { device } from '@styles/mediaQuery';
import Rocket from '@public/icons/rocket.svg';
import { ForwardedRef, forwardRef, RefObject } from 'react';
import { scrollTo } from '@utils/scrollTo';
import { JOIN } from '@shared/constants/navigate';

type ActionButtonProps = {
  width: string;
  margin: string;
  btnWidth: string;
};

function ConnectActionButtons(
  { width, margin, btnWidth }: ActionButtonProps,
  ref: ForwardedRef<HTMLDivElement>
) {
  const onJoinButtonClick = () => {
    window.location.href = JOIN;
  };

  const onCallButtonClick = () => {
    scrollTo(ref as RefObject<HTMLDivElement>, 'contacts');
  };

  return (
    <ButtonsWrapper $width={width} $margin={margin}>
      <Button
        height="45px"
        width={btnWidth}
        title="Join Us"
        bgColor="forestGreen"
        color="white"
        Icon={Rocket}
        onClick={onJoinButtonClick}
        gradient
      />

      <Button
        height="45px"
        width={btnWidth}
        title="Request a Call"
        bgColor="white"
        color="textPrimary"
        shadow={`0px 1px 3px ${theme.colors.divider}`}
        onClick={onCallButtonClick}
      />
    </ButtonsWrapper>
  );
}

const ButtonsWrapper = styled.div<{ $width: string; $margin: string }>`
  display: flex;
  justify-content: space-around;
  width: ${({ $width }) => $width};

  margin: ${({ $margin }) => $margin};

  ${device.laptopL(css`
    margin-top: 100px;
  `)};
`;

export default forwardRef<HTMLDivElement | null, ActionButtonProps>(
  ConnectActionButtons
);
